export const VEHICLE = 0;
export const PERSON = 1;

export const DRIVER_HAS_INTEREST = 1;
export const DRIVER_CONTACTED_YOU = 2;
export const YOU_CONTACTED_DRIVER = 3;
export const DRIVER_CLOSE_WITH_YOU = 4;
export const DRIVER_HIRED = 5;
export const SEARCHED_BY_YOU = 6;

export const PRIVATE_PERSON = 1;
export const JURIDICAL_PERSON = 2;

export const tagText = [
  'TEM INTERESSE',
  'INICIOU CONTATO COM VOCÊ',
  'VOCÊ INICIOU CONTATO',
  'MOTORISTA FECHOU COM VOCÊ',
  'CONTRATADO',
  'BUSCADO POR VOCÊ',
];

export enum CardAnimations {
  NONE,
  RIGHT,
}
